import { MAX_BUCKETS_LIMIT, SORT_DESC } from '@/constants/broker_metrics';
import type { BrokerBucketsResponse, BrokerMetricsMetaData, BrokerMetricsQueryParams, SortDirection } from '@/types/main';
import axios from 'axios';

const client = axios.create({
    baseURL: process.env.NEXT_PUBLIC_API_URL,
});

export async function fetchMetaApi(): Promise<BrokerMetricsMetaData | null> {
    try {
        const res = await client.get<BrokerMetricsMetaData>('/meta');
        return res.data;
    } catch {
        return null;
    }
}

export async function fetchBrokerData(
    brokers: string[],
    end: string,
    end_point: string,
    direction: SortDirection = SORT_DESC,
    start?: string
): Promise<BrokerBucketsResponse> {
    const params: BrokerMetricsQueryParams = {
        brokers: brokers.join(','),
        end_point,
        end,
        direction,
        limit: MAX_BUCKETS_LIMIT.toString(),
    };
    if (start) {
        params.start = start;
    }

    try {
        const res = await client.get<BrokerBucketsResponse>('/buckets', { params });
        return res.data;
    } catch {
        return {};
    }
}
